"use client";

import React, { useState, useEffect } from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
const testimonials = [{
  name: "Arjun Mehta",
  program: "MSc Finance",
  university: "University of Oxford, UK",
  quote: "Briviox transformed my application from standard to standout. Their deep understanding of the Oxford admission process was the key to my success. Truly where ambition meets achievement."
}, {
  name: "Elena Rodriguez",
  program: "LLM International Law",
  university: "Columbia University, USA",
  quote: "The personalized guidance I received for my Ivy League applications was unparalleled. Briviox didn't just help with paperwork; they helped me refine my vision for my legal career."
}, {
  name: "Li Wei",
  program: "BEng Computer Science",
  university: "University of Toronto, Canada",
  quote: "Navigating the Canadian study permit process seemed daunting until I met the Briviox team. Their efficiency and professional support made my transition to Toronto completely seamless."
}, {
  name: "Amara Okafor",
  program: "MPH Global Health",
  university: "King's College London, UK",
  quote: "The scholarship support at Briviox is exceptional. They identified opportunities I hadn't even considered, making my dream of studying in London a financially viable reality."
}, {
  name: "David Chen",
  program: "MBA",
  university: "Stanford University, USA",
  quote: "Professionalism and institutional knowledge are the hallmarks of Briviox. They provided a strategic roadmap for my MBA journey that was both realistic and highly aspirational."
}];
export default function GlobalSuccessStories() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="13768" id="student-success-stories" className="bg-muted py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-default font-bold text-primary mb-4 tracking-tight">
            Voices of Achievement
          </h2>
          <p className="text-muted-foreground text-xl font-sans">
            Join the elite circle of Briviox alumni who have secured their futures at the world's most prestigious institutions.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <Carousel setApi={setApi} opts={{
          align: "center",
          loop: true
        }} className="w-full select-none">
            <CarouselContent className="-ml-4 py-10">
              {testimonials.map((item, i) => {
              const isActive = current === i;
              return <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3 transition-all duration-500 ease-out">
                    <div className={cn("h-full transition-all duration-500 ease-out transform", isActive ? "scale-105 opacity-100 z-10" : "scale-90 opacity-60 z-0 blur-[1px]")}>
                      <Card className="h-full bg-card border-none shadow-xl hover:shadow-2xl transition-shadow duration-300 rounded-sm">
                        <CardContent className="p-8 flex flex-col items-center text-center h-full justify-center">
                          <Quote className="size-10 text-secondary mb-6 fill-secondary/10" />
                          <p className="text-primary/90 italic mb-8 text-xl leading-relaxed font-serif">
                            &ldquo;{item.quote}&rdquo;
                          </p>
                          <div className="mt-auto">
                            <h4 className="text-primary font-default font-bold text-2xl mb-1">
                              {item.name}
                            </h4>
                            <p className="text-secondary font-sans font-medium text-sm uppercase tracking-wider">
                              {item.program}
                            </p>
                            <p className="text-muted-foreground/80 font-sans text-sm mt-1">
                              {item.university}
                            </p>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                  </CarouselItem>;
            })}
            </CarouselContent>

            {}
            <CarouselPrevious className="hidden md:flex -left-12 border-primary/10 text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300" />
            <CarouselNext className="hidden md:flex -right-12 border-primary/10 text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300" />

            {}
            <div className="flex justify-center gap-3 mt-8">
              {Array.from({
              length: count
            }).map((_, index) => <button key={index} data-index={index} onClick={() => api?.scrollTo(index)} className={cn("rounded-full transition-all duration-300", current === index ? "size-4 bg-secondary scale-110" : "size-3 bg-primary/20 hover:bg-primary/40")} aria-label={`Go to slide ${index + 1}`} />)}
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}